/**
 * POST /leads — publishes the "Get Early Access" form submission as a
 * contact/lead. Same envelope + base URL as the impact endpoints, via the
 * shared apiClient.
 */
import { postJson } from '../../../services/apiClient';

interface CreateLeadRequestBody {
  first_name: string;
  last_name: string;
  donation_amount: number;
  email: string;
  phone_number?: string;
}

export interface LeadContact {
  contactId: string;
  email: string;
  createdAt: string;
  updatedAt: string;
  archived: boolean;
}

export interface CreateLeadParams {
  firstName: string;
  lastName: string;
  donationAmount: number;
  email: string;
  /** "+1 617 555 0100" style — omit the field entirely when not provided. */
  phoneNumber?: string;
}

export async function createLead({
  firstName,
  lastName,
  donationAmount,
  email,
  phoneNumber,
}: CreateLeadParams): Promise<LeadContact> {
  const body: CreateLeadRequestBody = {
    first_name: firstName,
    last_name: lastName,
    donation_amount: donationAmount,
    email,
    ...(phoneNumber ? { phone_number: phoneNumber } : {}),
  };
  return postJson<LeadContact>('/leads', body);
}
